import React, { useState } from "react"
import { useLaboratoryKit } from "../Hooks/useLaboratoryKit"
import InventoryLaboratoryKitService from "../../../api/Inventory/InventoryLaboratoryKitService"
import { ErrorMessage, Success } from "../../../components/Notifications/Notifications"
import { useHistory } from "react-router-dom";
import { InventoryTab, inventoryTabTarget } from './inventoryTabNavigation';
import { useTranslation } from "react-i18next";
import Card from "../../../components/Cards/Card";
import { Col, Row } from 'react-bootstrap';
import useConfirmationModal from "../../../components/Modals/ConfirmationModal/useConfirmationModal";

export default function CreateLaboratoryKitPage({ match: { params } }) {
    const history = useHistory();
    const { t } = useTranslation();
    const { itemId } = params
    const [laboratoryKit, isLoading, reload] = useLaboratoryKit(itemId)
    const [state, setState] = useState(laboratoryKit)
    const [ConfirmationModal, modalActions] = useConfirmationModal()

    const handleSubmit = async () => {

        modalActions.Show({
            title: t('inventory.movements.confirmations.completeTitle'),
            textContent: t('inventory.movements.confirmations.completeTextContent'),
            buttonText: t('buttons.confirm'),
            useComment: false,
            onConfirmation: async () => {
                try {
                    const result = await InventoryLaboratoryKitService.Create({ ...state })
                    if (result.Succeeded) {
                        Success(t('inventory.commons.laboratoryKitCreatedSuccessfully'))
                        history.push(inventoryTabTarget(InventoryTab.laboratoryKitInventory));
                    } else {
                        ErrorMessage(result.Errors?.length > 0 ? result.Errors[0] : t('inventory.commons.laboratoryKitDuplicateName'));
                    }
                } catch (error) {
                    if (error.response && error.response.status === 400) {
                        const validationErrors = error.response.data?.Errors;
                        ErrorMessage(validationErrors?.length > 0 ? validationErrors[0] : t('inventory.commons.laboratoryKitDuplicateName'));
                    } else {
                        ErrorMessage(t('errors.serverError'));
                    }
                }
            }
        })
    }

    const handleOnChange = (e) => {
        const value = e.target.value
        setState({
            ...state,
            presentation: value
        })
    }

    const handleCancel = () => {
        history.push(inventoryTabTarget(InventoryTab.laboratoryKitInventory));
    }

    return (<>
        <Card
            header={<div>
                <h4>{t('inventory.commons.laboratoryKit')}</h4>
            </div>}
            content={<form>
                <div style={{ marginBottom: '2rem' }}>
                    <Row>
                        <Col sm={12} md={6}>
                            <div style={{ display: 'flex', gap: '2rem', alignItems: 'center', verticalAlign: 'middle' }}>
                                <div style={{ width: '10rem' }}>
                                    <label>{t('commons.description')}</label>
                                </div>
                                <input type="text" className="form-control" value={state.presentation} onChange={handleOnChange} />
                            </div>
                        </Col>
                    </Row>

                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                    <button className="btn btn-secondary" type="button" onClick={handleCancel}>{t('buttons.back')}</button>
                    <button className="btn btn-success" type="button" onClick={handleSubmit}>{t('buttons.save')}</button>
                </div>
            </form>}>
        </Card>
        <ConfirmationModal />
    </>)
}